export const PLAYBACK_RATES = [1, 1.25, 1.5, 1.75, 2];
export const PLAYBACK_RATES_MAP = [
  { rate: 1, display: '1\u00D7' },
  { rate: 1.25, display: '1.2\u00D7' },
  { rate: 1.5, display: '1.5\u00D7' },
  { rate: 1.75, display: '1.7\u00D7' },
  { rate: 2, display: '2\u00D7' },
];
